import { useMemo } from 'react';

import WarningSolid from '@simplywallst/ui-core/icons/WarningSolid';

import { Error } from './Error';
import { getErrorMessage } from './getErrorMessage';

type Props = {
  error: unknown;
  onDismiss: () => void;
};

export const MutationError = ({ error, onDismiss }: Props) => {
  const message = useMemo(() => getErrorMessage(error), [error]);

  return (
    <Error onDismiss={onDismiss}>
      <div className="grid h-full grid-cols-[24px_calc(100vw-100px)] items-center gap-x0_5 sm:grid-cols-[24px_max-content]">
        <svg width="24" height="24" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="6" fill="#FFF" />
          <WarningSolid className="fill-bad" />
        </svg>
        <span className="text-pretty text-xs text-solid">{message}</span>
      </div>
    </Error>
  );
};
